import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {Component, Prop} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class BackupFilePreviewDialogComponent extends VueWrapper {
    public $refs!: {};

    @Prop({
        type: String,
        default: () => {
            return 'backup-file-preview-dialog';
        },
    })
    public readonly name!: string;

    @Prop({
        type: String,
    })
    public fileContent!: string;

    public open() {
        if (this.CoreSrv.isModalOpened(this.name)) {
            this.close();
        }
        this.CoreSrv.OpenModal(this.name);
    }
    public close() {
        this.CoreSrv.CloseModal(this.name);
    }
}
